import { useMemo } from 'react';
import useActiveStore from './useActiveStore';
import { filterStoresByAssignment } from '../utils/assignedStores';
import { storeDisplayName } from '../utils/storeEntity';

/**
 * Maps the current user's assigned stores onto a store list for dropdowns.
 * 0 assigned → all stores (optional "All stores" row).
 * 1 assigned → storeLocked.
 * 2+ assigned → only those stores, unlocked.
 */
export default function useAssignedStoreOptions(stores, { allLabel } = {}) {
  const scope = useActiveStore();
  const scopedStores = useMemo(
    () => filterStoresByAssignment(stores, scope.assignedStoreIds),
    [stores, scope.assignedStoreIds],
  );
  const storeOptions = useMemo(() => {
    const opts = scopedStores.map((s) => ({
      value: s.store_id || s.id,
      label: storeDisplayName(s),
    }));
    if (allLabel && !scope.isStoreScoped) {
      return [{ value: '', label: allLabel }, ...opts];
    }
    return opts;
  }, [scopedStores, allLabel, scope.isStoreScoped]);

  return { ...scope, scopedStores, storeOptions };
}
